import React, { useEffect } from 'react';
import PT from 'prop-types';
import TranslatorManager from 'ts-translate-js';
import { map, size } from 'lodash';
import accounting from 'accounting';
import { PleaseWaitSpinner } from './utilctl';

const tr = TranslatorManager.boundTR;

export const PrepaidCardPanel = 
    function({ prepaidCards, cartTotal, showAddPrepaidCardPanel, errorMessage, addingCard, onRemoveCard, onAddCard, onAddFormToggle, onContentChange }) {
        useEffect(() => {
            if (onContentChange !== undefined) 
                onContentChange();
        });

        let panel = null;
        if (addingCard)
            panel = <PleaseWaitSpinner size="md" />;
        else if (size(prepaidCards) === 0) {
            if (showAddPrepaidCardPanel)
                panel = <AddPrepaidCardForm 
                    onContentChange={onContentChange} 
                    onCancel={onAddFormToggle}
                    onAddPrepaidCard={onAddCard} 
                    errorMessage={errorMessage}
                />;
            else
                panel = <div>
                    <div className="form-group">
                        <div className="col-sm-7">
                            <button className="btn btn-default btn-lg" onClick={onAddFormToggle}>
                                <span className="fas fa-gift"></span> <span>{tr("Utiliser une carte cadeau")}</span>
                            </button>    
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12">
                            <hr />
                        </div>
                    </div>
                </div>;
        }
        else 
            panel = <div>
                <PrepaidCardList prepaidCards={prepaidCards} cartTotal={cartTotal} onRemoveCard={onRemoveCard} />
                <div className="row">
                    <div className="col-sm-7">
                        <button className="btn btn-default btn-xs" onClick={onAddFormToggle}>
                            <span className="fas fa-gift"></span> <span>{tr("Ajouter une carte cadeau")}</span>
                        </button>
                    </div>
                </div>
                { errorMessage != undefined && !showAddPrepaidCardPanel?
                    <div className="row">
                        <div className="col-sm-8">
                            <div className="alert alert-danger text-center" role="alert">{errorMessage}</div>
                        </div>
                    </div>
                    : null
                }
                <div className="row">
                    <div className="col-xs-12">
                        <hr />
                    </div>
                </div>
                { showAddPrepaidCardPanel ? 
                    <AddPrepaidCardForm 
                        onContentChange={onContentChange} 
                        onCancel={onAddFormToggle}
                        onAddPrepaidCard={onAddCard}
                        errorMessage={errorMessage}
                    /> : null 
                }
            </div>;

        return <div>
            {panel}
        </div>;
    };
PrepaidCardPanel.propTypes = {
    prepaidCards: PT.arrayOf(PT.shape({
        PrepaidCardID: PT.string,
        Number: PT.string,
        Balande: PT.number
    })),
    cartTotal: PT.number,
    showAddPrepaidCardPanel: PT.bool,
    addingCard: PT.bool,
    errorMessage: PT.string,
    onRemoveCard: PT.func,
    onAddCard: PT.func,
    onContentChange: PT.func,
    onAddFormToggle: PT.func
};

export const PrepaidCardList =
    function PrepaidCardList({ prepaidCards, cartTotal, onRemoveCard }) {
        const handleRemoveCard = (e, cardId) => {
            e.preventDefault();
            e.stopPropagation();
            if (onRemoveCard != undefined) onRemoveCard(cardId);
        }

        let prepaidCardAmountApplied = 0;
        return <div>
            { map(prepaidCards, (card, i) => {
                  let amountToApply;
                  if (prepaidCardAmountApplied + card.Balance < cartTotal) {
                      amountToApply = card.Balance;
                  } else {
                      amountToApply = cartTotal - prepaidCardAmountApplied;
                  }
                  prepaidCardAmountApplied += amountToApply;
                  return <div className="form-group" key={i}>
                      <div className="col-xs-6 col-sm-3 control-label left">
                          {tr("Carte cadeau")} <b>#{card.Number}</b>
                          <p><i>{tr("(valeur de {amount})", { amount: accounting.formatMoney(card.Balance) })}</i></p>
                      </div>
                      <div className="col-xs-4 col-sm-2">
                          <div className="text-right amount">
                              <b>{accounting.formatMoney(amountToApply)}</b>
                          </div>
                      </div>
                      <div className="col-xs-2 col-sm-1 control-label left"><a href="#" onClick={(e) => handleRemoveCard(e, card.PrepaidCardID)}>{tr("retirer")}</a></div>
                      <br />
                  </div>;
              })}
        </div>;
    };
PrepaidCardList.propTypes = {
    prepaidCards: PT.arrayOf(PT.shape({
        PrepaidCardID: PT.string,
        Number: PT.string,
        Balande: PT.number
    })),
    cartTotal: PT.number,
    onRemoveCard: PT.func
};


export const AddPrepaidCardForm = 
    class AddPrepaidCardForm extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                wantedPrepaidCardNumber: null,
            };
            
            this.handleAddCardClick = this.addPrepaidCard.bind(this);
            this.handlePrepaidCardAmountChange = this.handlePrepaidCardAmountChange.bind(this);
            this.handlePrepaidCardNumberChange = this.handlePrepaidCardNumberChange.bind(this);
        }
        
        componentDidMount() {
            if (this.props.onContentChange !== undefined) {
                this.props.onContentChange();
            }
        }

        componentDidUpdate() {
            if (this.props.onContentChange !== undefined) {
                this.props.onContentChange();
            }
        }

        addPrepaidCard() {
            if (this.props.onAddPrepaidCard != undefined) 
                this.props.onAddPrepaidCard(this.state.wantedPrepaidCardNumber);
        }


        handlePrepaidCardNumberChange(e) {
            this.setState({ wantedPrepaidCardNumber : e.target.value });
        }

        handlePrepaidCardAmountChange(e) { 
            this.start = e.target.selectionStart;
            
            let val = e.target.value;
            val = val.replace(/([^0-9.]+)/, ""); // Remove all non-digit characters
            val = val.replace(/^(0|\.)/, ""); // Find last zero before a "." or "." itself
            val = val.replace(/^(0|\,)/, "");  // Find last zero before a "," or "," itself
            
            const match = /(\d{0,7})[^.]*((?:\.\d{0,2})?)/g.exec(val); // Find match by groups
            const amount = match[1] + match[2]; // Assemble result
            e.target.value = amount;
            
            if (val.length > 0) {
                const finalAmount = Number(amount).toFixed(2);
                if (finalAmount !== Number(0.00).toFixed(2)) {
                    e.target.value = finalAmount;
                    e.target.setSelectionRange(this.start, this.start); // Allow to place the caret after "." or "," if there is one
                    this.setState({ choosenAmount: finalAmount });
                } else {
                    e.target.value = null;
                    this.setState({ choosenAmount: null });
                }
            }
        }
        
        render() {
            return <div className="prepaid-card-form">
                <div className="row">
                    <div className="col-sm-12">
                        <h5>{tr("Ajout d'une carte")}</h5>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <span>{tr("Veuillez entrer le numéro de votre carte cadeau")}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-7 col-xs-12">
                        <input id="prepaidCardNumber" autoFocus value={this.state.wantedPrepaidCardNumber || ""} onChange={this.handlePrepaidCardNumberChange}></input>
                    </div>
                </div>
                { this.props.errorMessage != undefined ?
                  <div className="row">
                    <div className="col-sm-8">
                          <div className="alert alert-danger text-center" role="alert">{this.props.errorMessage}</div>
                      </div>
                  </div>
                  : null
                }
                <br />
                <div className="row">
                    <div className="col-sm-12">
                        <div className="btn-toolbar">
                            <div className="btn-group">
                                <button className="btn btn-default" onClick={this.props.onCancel}>{tr("button.cancel")}</button>
                            </div>
                            <div className="btn-group">
                                <button className="btn btn-primary" onClick={this.handleAddCardClick}>{tr("Ajouter")}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>;
        }
    }
AddPrepaidCardForm.propTypes = {
    onCancel: PT.func,
    onAddPrepaidCard: PT.func,
    onContentChange: PT.func,
    errorMessage: PT.string
};
